export class State {
    id: string;
    name: string;
}
